const keyCardApiPath = "/api/key-card";
export const signUpPath = "/api/signup";

const params = new URLSearchParams(location.search);

function getHostname() {
	const hostParam = params.get("_host");
	if (hostParam) {
		return hostParam;
	}
	switch (location.hostname) {
		case "dev.safecube.io":
			return "admin-dev.safecube.io";
		case "localhost":
			return "localhost:52000";

		case "safecube.io":
		default:
			return "admin.safecube.io";
	}
}
const hostname = getHostname();

function getSecureModifier() {
	const secure = params.get("_secure");
	if (secure) {
		return "s";
	}
	return location.protocol.indexOf("https") === 0 ? "s" : "";
}

export const secureModifier = getSecureModifier();

// websocket cannot be proxied on localhost...
export const wsHost = hostname;

export function getSocketUrl(token: string, endpoint: string) {
	return `ws${secureModifier}://${wsHost}${keyCardApiPath}${endpoint}?authToken=${token}`;
}

export function getRestUrl(apiPath: string, endpoint?: string) {
	return `http${secureModifier}://${hostname}${apiPath}${endpoint || ""}`;
}

export function getKeyCardRestUrl(endpoint: string) {
	return getRestUrl(keyCardApiPath, endpoint);
}

export function getSignUpUrl() {
	return getRestUrl(signUpPath);
}
